"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectAddress = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _selectors = require("../../../../../redux/selectors");
var _actions = require("../../../../../redux/actions");
var _shared = require("../../../../../shared");
var _functions = require("../../../../../utils/functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SelectAddress = exports.SelectAddress = /*#__PURE__*/(0, _react.memo)(() => {
  const activeBuildings = (0, _reactRedux.useSelector)(_selectors.selectActiveBuildings, _functions.simpleEqualValues);
  const buildingsGroups = (0, _reactRedux.useSelector)(_selectors.selectBuildings);
  const dispatch = (0, _reactRedux.useDispatch)();
  const [options, setOptions] = (0, _react.useState)([]);
  const tV = (0, _paulCorePackage.useTranslationValue)();
  const updateSelector = value => dispatch((0, _actions.setActiveBuildings)(value));
  const {
    9: tBuildings
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  (0, _react.useEffect)(() => {
    if (!buildingsGroups.length) return;
    setOptions(buildingsGroups.map((group, index) => {
      var _group$, _group$2;
      const buildingStreet = tV((_group$ = group[0]) === null || _group$ === void 0 ? void 0 : _group$.thingBuildingStreet);
      const houseNumbers = group.map(building => " ".concat(tV(building.thingBuildingHouseNumber)));
      return {
        value: ((_group$2 = group[0]) === null || _group$2 === void 0 ? void 0 : _group$2.id) || index,
        label: "".concat(buildingStreet, " ").concat(houseNumbers)
      };
    }));
  }, [tV, buildingsGroups]);
  return /*#__PURE__*/_react.default.createElement(_shared.Selector, {
    item: {
      defaultValue: tBuildings,
      type: 'select',
      name: 'activeBuildings'
    },
    value: activeBuildings,
    setValue: updateSelector,
    options: options,
    helperText: ""
  });
});